import { Grid, TextField, Button, Typography, Grow } from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../app/hooks";
import {
  selectCalculatorState,
  setActiveOutlaysInnerStep,
  setOutlaysInnerAllowNextStep,
  setTotalTransport,
  setTransportData,
  setTotal,
  setActiveStep,
} from "../../../../../../calculatorSlice";
import { ITransportData } from "../../../../../../../../lib/interfaces/IFixedOutlay";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import sum from "../../../../../../../../lib/utils/sum";
import { NumberFormatCustom } from "../../../../../FormattedInputs";
import ArrowLeft from "../../../../../../assets/arrow-left.svg";
import ArrowRight from "../../../../../../assets/arrow-right.svg";
import { CustomTextFiled } from "../../../../../CustomTextFiled";
import { useState } from "react";

function TransportForm() {
  const dispatch = useAppDispatch();
  const CalculatorState = useAppSelector(selectCalculatorState);
  const { transportData } = useAppSelector(selectCalculatorState);
  const [initialTransportData] = useState(transportData); // Store the initial transportData for comparison

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<ITransportData>({
    defaultValues: transportData,
  });
  const handleBackClick = () => {
    if (CalculatorState.allowedSteps > 0) {
      if (
        CalculatorState.outlaysInnerAllowedSteps >= 0 &&
        CalculatorState.outlaysInnerActiveStep === 0
      ) {
        dispatch(setActiveStep(0));
      }
      if (
        CalculatorState.outlaysInnerAllowedSteps > 0 &&
        CalculatorState.outlaysInnerActiveStep > 0
      ) {
        dispatch(
          setActiveOutlaysInnerStep(CalculatorState.outlaysInnerActiveStep - 1)
        );
      }
    }
  };
  const onSubmit: SubmitHandler<ITransportData> = (data) => {
    let temp;
    delete data.transportTotal;
    if (
      data.carInsurance &&
      data.carInsurance !== initialTransportData.carInsurance
    ) {
      temp = data?.carInsurance / 1 || 0;
      delete data.carInsurance;
      const tempo = Number(temp).toFixed(2);
      data.carInsurance = Number(tempo);
    }

    if (
      data.carMaintenance &&
      data.carMaintenance !== initialTransportData.carMaintenance
    ) {
      temp = data?.carMaintenance / 1 || 0;
      delete data.carMaintenance;
      const tempo = Number(temp).toFixed(2);
      data.carMaintenance = Number(tempo);
    }

    if (data.carTest && data.carTest !== initialTransportData.carTest) {
      temp = data?.carTest / 1 || 0;
      delete data.carTest;
      const tempo = Number(temp).toFixed(2);
      data.carTest = Number(tempo);
    }
    const sumWithInitialValue = sum(data);
    console.log(data);
    dispatch(setTransportData(data));
    dispatch(setTotalTransport(sumWithInitialValue));
    dispatch(setTotal());
    dispatch(setOutlaysInnerAllowNextStep(2));
    dispatch(setActiveOutlaysInnerStep(2));
  };

  const divideBy12 = (value: number | undefined): number => {
    return value ? Number((value / 12).toFixed(2)) : 0;
  };

  return (
    <Grid
      sx={{ textAlign: "center", display: "grid", placeItems: "center" }}
      container
    >
      <Grid item>
        <br />
        <Grow timeout={{ enter: 900, exit: 100 }} in={true}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <h3
              style={{
                textAlign: "center",
                fontWeight: "700",
                width: "100%",
                fontSize: "1.75rem",
                padding: 0,
              }}
            >
              רכב
            </h3>

            <Controller
              name="carInsurance"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.carInsurance}
                  helperText={errors.carInsurance && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label="ביטוח רכב - תשלום שנתי"
                  variant="filled"
                />
              )}
            />
            <Controller
              name="carTest"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.carTest}
                  helperText={errors.carTest && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label="טסט - תשלום שנתי"
                  variant="filled"
                />
              )}
            />
            <Controller
              name="carMaintenance"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.carMaintenance}
                  helperText={errors.carMaintenance && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label="טיפולים - עלות שנתית"
                  variant="filled"
                />
              )}
            />
            <Controller
              name="publicTransport"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.publicTransport}
                  helperText={errors.publicTransport && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label="חופשי חודשי"
                  variant="filled"
                />
              )}
            />
            <br />
            <div
              style={{
                display: "grid",
                placeItems: "center",
                alignItems: "center",
              }}
            >
              <br />
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  alignItems: "center",
                  gridTemplateColumns: "auto auto",
                  alignContent: "center",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <button onClick={handleBackClick} className="back">
                  <img
                    src={ArrowRight}
                    alt="arrow"
                    style={{ marginBottom: "0.25rem" }}
                  />
                  <Typography
                    sx={{ fontSize: "1.2rem", color: "black" }}
                    display="block"
                    gutterBottom
                  >
                    הקודם
                  </Typography>
                </button>
                <button className="btn next" type="submit">
                  <Typography
                    sx={{ fontSize: "1.2rem" }}
                    display="block"
                    gutterBottom
                  >
                    הבא
                  </Typography>
                  <img
                    src={ArrowLeft}
                    alt="arrow"
                    style={{ marginBottom: "0.25rem" }}
                  />
                </button>
              </div>
            </div>
          </form>
        </Grow>
        <br />
      </Grid>
    </Grid>
  );
}

export default TransportForm;
